import { z } from "zod";
import { brandSlug } from "./brands";

// Admission checks only. The existing capture runner also checks DNS and every
// redirect before fetching; a syntactically public hostname is not DNS proof.
function publicWebsite(value: string): boolean {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase().replace(/\.$/u, "");
    return ["http:", "https:"].includes(url.protocol)
      && !url.username && !url.password && !url.port
      && host.includes(".") && !host.includes(":")
      && !/^\d+(?:\.\d+){3}$/u.test(host)
      && !/(?:^|\.)(?:localhost|local|internal|lan|home|test|invalid)$/u.test(host);
  } catch { return false; }
}

export const brandCreationSchema = z.object({
  name: z.string().trim().min(1, "Enter the brand name.").max(160, "Keep the brand name under 161 characters.")
    .refine((value) => Boolean(brandSlug(value)), "Enter a brand name containing letters or numbers."),
  homepageUrl: z.string().trim().max(2048, "This website URL is too long.")
    .refine(publicWebsite, "Enter a public http:// or https:// website URL without a login or custom port.")
    .transform((value) => { const url = new URL(value); url.hash = ""; return url.toString(); }),
});

export type BrandCreationInput = z.input<typeof brandCreationSchema>;
export type BrandCreationResult = {
  created: boolean;
  brand: { slug: string; publicId: string | null; name: string; homepageUrl: string | null };
  scan: { jobId: string | null; status: string } | null;
};

export function brandWebsiteHost(value: string | null): string | null {
  if (!value) return null;
  try { return new URL(value).hostname.toLowerCase().replace(/\.$/u, "").replace(/^www\./u, ""); }
  catch { return null; }
}
